import { z } from 'zod';

export const nonEmptyString = z.string().trim().min(1);

export const iconSchema = z.object({
  src: nonEmptyString,
  alt: nonEmptyString,
});
